import React from 'react';
import {
  faChevronRight,
  faClock,
  faUser,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDashboardContext } from '../../context';
import { useGlobalContext } from '../../../../globalContext';
import { useMessageDetailsMutation } from '../../../../features/authentication/messageApiSlice';
import UiVirtualScroll from '../../../../components/VirtualScroll';
import { useGetAllAlertsMutation } from '../../../../features/authentication/authApiSlice';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import deleteMenu from '../../../../assets/images/deleteMenu.png';
import html2pdf from 'html2pdf.js';
import ProgressButton from '../../../../components/ProgressButton';

const Sent = () => {
  const [expand, setExpand] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(1);
  const [getAllAlerts] = useGetAllAlertsMutation();
  const [messageDetail] = useMessageDetailsMutation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedMessageId, setSelectedMessageId] = React.useState([]);

  const [singlemessageDetails, setSinglemessageDetails] = React.useState();
  const messageDetails = useDashboardContext();
  const context = useGlobalContext();

  const buffer = messageDetails.limit * 3;
  const cache = buffer - messageDetails.limit;

  const [showDeleteConfirmationNotification, setShowDeleteConfirmationNotification] =
    React.useState(false);
  const [singleDeleteId, setSingleDeleteId] = React.useState(false);
  
  const [isPdfGenerating, setIsPdfGenerating] = React.useState(false);

  React.useEffect(() => {
    messageDetails.setAllMessage([]);
    loadInitialData();
  }, [messageDetails.activeButton]);

  const loadMessageHandler = async (id) => {
    const allMessageGroupResponse = await messageDetail(id).unwrap();
    console.log(allMessageGroupResponse);
    setSinglemessageDetails(() => allMessageGroupResponse);
  };

  const expandhandler = async (index, id) => {
    setSinglemessageDetails(null);
    if (index !== activeIndex.index || !expand) {
      setSelectedMessageId(id);
      loadMessageHandler(id);
    } else {
      setSelectedMessageId();
    }
    setActiveIndex({ index: index == activeIndex.index ? -1 : index, id: id });
    setExpand(index !== activeIndex.index || !expand);
  };

  const selectHandler = (value) => {
    if (messageDetails.messageDetail.selectedMessages.includes(value.alertID)) {
      // If the checkbox is already selected, remove it from the array
      const updatedSelectedMessages = messageDetails.messageDetail.selectedMessages.filter(
        (id) => id !== value.alertID
      );
      messageDetails.setMessageDetail({
        ...messageDetails.messageDetail,
        selectedMessages: updatedSelectedMessages,
        allInboxChecked: false
      });
    } else {
      // If the checkbox is not selected, add it to the array
      messageDetails.setMessageDetail({
        ...messageDetails.messageDetail,
        selectedMessages: [...messageDetails.messageDetail.selectedMessages, value.alertID],
        allInboxChecked: false
      });
    }
  };

  const deleteHandler = async (id) => {
    setSingleDeleteId(id);
    setShowDeleteConfirmationNotification(true);
  };

  const deleteSingleMessage = async (status) => {
    setShowDeleteConfirmationNotification(false);
    if (status) {
      try {
        await messageDetails.deleteHandler(singleDeleteId);
        await context.getAllAlertsAsync(2);
      } catch (error) {
        console.log(error);
      }
    } else {
      setSingleDeleteId(null);
    }
  };

  async function getAllAlertsAsync(skip, take, type) {
    try {
      const allAlertsResponse = await getAllAlerts({
        skip: skip,
        take: take,
        viewType: type,
        orderBy: messageDetails.activeButton
      }).unwrap();
      console.log(allAlertsResponse);
      return allAlertsResponse;
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  const loadInitialData = async () => {
    setIsLoading(true);
    const { total, data } = await getAllAlertsAsync(0, buffer, 2);
    messageDetails.setAllMessage(data);
    messageDetails.setNoOFOutboxMessage(total);
    setIsLoading(false);
  };

  const prevCallback = async (newOffset) => {
    setIsLoading(true);
    const { total, data } = await getAllAlertsAsync(newOffset, messageDetails.limit, 2);
    const newItems = [...data, ...messageDetails.allMessage.slice(0, cache)];
    messageDetails.setAllMessage(newItems);
    messageDetails.setNoOFOutboxMessage(total);
    setIsLoading(false);
  };

  const nextCallback = async (newOffset) => {
    setIsLoading(true);
    const { total, data } = await getAllAlertsAsync(newOffset, messageDetails.limit, 2);
    const newItems = [...messageDetails.allMessage.slice(-cache), ...data];
    messageDetails.setAllMessage(newItems);
    messageDetails.setNoOFOutboxMessage(total);
    setIsLoading(false);
  };

  const handlePrint = async (index) => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const options = {
      margin: 60,
      filename: 'SentMessage.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }
    };
    const contentWrapper = document.getElementById('index-' + index);
    const contentClone = contentWrapper.cloneNode(true);
    const buttonElements = contentClone.querySelectorAll('button');
    buttonElements.forEach((buttonElement) => {
      buttonElement.classList.add('d-none');
    });

    const subjectTag = contentClone.getElementsByClassName('subjectH6Tag')[0];
    if (subjectTag) {
      subjectTag.style.whiteSpace = 'initial';
      subjectTag.classList.add('mb-3');
      var parentDiv = subjectTag.parentNode;
      if (parentDiv) {
        parentDiv.classList.remove('d-flex');
      }
    }

    const recipientsSpan = contentClone.getElementsByClassName('recipientsSpan');
    recipientsSpan.forEach((span) => {
      if (span.classList.contains('d-none')) {
        span.classList.remove('d-none');
      } else {
        span.classList.add('d-none');
      }
    });

    const inputElements = contentClone.querySelectorAll('input');
    inputElements.forEach((inputElement) => {
      inputElement.classList.add('d-none');
    });

    await html2pdf().set(options).from(contentClone).save('SentMessage.pdf');
    setIsPdfGenerating(false);
  };

  return (
    <UiVirtualScroll
      buffer={buffer}
      rowHeight={95}
      height="400px"
      total={messageDetails.noOFOutboxMessage}
      limit={messageDetails.limit}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      onPrevCallback={prevCallback}
      onNextCallback={nextCallback}>
      {messageDetails.allMessage.map((value, index) => (
        <div key={index} className="message-box position-relative mb-3" id={`index-${index}`}>
          <div className="message-header d-flex flex-column flex-md-row align-items-md-center">
            <div className="form-check flex-shrink-0 me-3">
              <input
                className="form-check-input"
                type="checkbox"
                value={value.alertID}
                id={`checkbox-${index}`}
                onChange={() => selectHandler(value)}
                checked={messageDetails.messageDetail.selectedMessages.includes(value.alertID)}
              />
            </div>

            <div className="message-content d-flex  flex-column flex-sm-row  align-items-sm-center w-100 mt-3 mt-md-0">
              <div className="message-user rounded-circle flex-shrink-0 me-3 mb-3 mb-sm-0">
                {`${value?.fName?.slice(0, 1).toUpperCase()}${value?.lName
                  ?.slice(0, 1)
                  .toUpperCase()}`}
              </div>
              <div className="message-content-in w-100">
                <div className="d-flex flex-column flex-md-row">
                  <h6 className="subjectH6Tag mb-0 text-truncate order-2 order-md-1">
                    {value.subject}
                  </h6>
                  <div className="message-date d-flex flex-wrap gap-2 order-1 order-md-2 flex-shrink-0 mb-2 mb-md-0 ms-md-auto">
                    <div className="recipientsSpan">
                      <FontAwesomeIcon className="me-2" icon={faUser} />
                      {value.recipients?.split(',')[0]}
                    </div>
                    <div className="recipientsSpan d-none">
                      <FontAwesomeIcon className="me-2" icon={faUser} />
                      {value.recipients}
                    </div>
                    <OverlayTrigger
                      key="recipient"
                      placement="top"
                      overlay={
                        <Tooltip className="recipients-tooltip">{value.recipients}</Tooltip>
                      }>
                      <span className="recipientsSpan">
                        {value.recipients?.split(',').length > 1 && <span>& more</span>}
                      </span>
                    </OverlayTrigger>
                    <div>
                      <FontAwesomeIcon className="me-2" icon={faClock} />
                      {new Date(value.tStamp).toLocaleString('default', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true
                      })}
                    </div>
                  </div>
                </div>
                {value.alertID !== selectedMessageId && (
                  <p className="mt-2 mb-0 text-truncate">{value.message}</p>
                )}
              </div>
            </div>
            <button
              onClick={() => expandhandler(index, value.alertID)}
              className="message-icon rounded-circle">
              <FontAwesomeIcon
                style={{
                  transform: `${
                    activeIndex.index == index && expand ? 'rotate(90deg)' : 'rotate(0deg)'
                  }`
                }}
                icon={faChevronRight}
              />
            </button>
          </div>
          {activeIndex.index == index && expand && (
            <div className="message-details pt-3">
              {singlemessageDetails?.assignmentName && (
                <p>
                  Assignment Name: <strong>{singlemessageDetails.assignmentName}</strong>
                </p>
              )}
              {singlemessageDetails?.course && (
                <p>
                  Course: <strong>{singlemessageDetails.course}</strong>
                </p>
              )}
              {singlemessageDetails?.activity && (
                <p>
                  Activity: <strong>{singlemessageDetails.activity}</strong>
                </p>
              )}
              {singlemessageDetails?.message && (
                <p className="mt-3">{singlemessageDetails.message}</p>
              )}
              <div className="mt-4 d-flex gap-3">
                <button
                  onClick={() => deleteHandler(value.alertID)}
                  className="btn btn-castleWhite btn-width">
                  <FontAwesomeIcon className="me-2" icon={faTrashAlt} /> Delete
                </button>
                <ProgressButton
                  isLoading={isPdfGenerating}
                  onClick={() => handlePrint(index)}
                  loadingLabel="Generating PDF"
                  label="Print to PDF"
                  className="btn btn-castleRed"
                  expectedDuration={1500}
                />
              </div>
            </div>
          )}
        </div>
      ))}
      <ConfirmationModal
        isOpen={showDeleteConfirmationNotification}
        onClose={() => deleteSingleMessage(false)}
        onSave={() => deleteSingleMessage(true)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          'Are you sure that you want to delete the message? The operation cannot be UNDONE!'
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
        showIcon={true}
        icon={deleteMenu}
      />
    </UiVirtualScroll>
  );
};

export default Sent;
